/** @file displayPoint: a screen point of the view on the view plane, in Babylon display coordinates. */
import type { View } from '@zilo/pose3d-render-core/camera/viewOf';
import type { V3 } from './matrixRows';

/** Writes into `out` where screen px `(x, y)` lies on the view plane through the target (Babylon display frame). */
export function displayPoint(out: V3, x: number, y: number, v: View): void {
  const a = (x - v.originX) / v.pixelsPerUnit;
  const b = (y - v.originY) / v.pixelsPerUnit;
  const { right: r, up: u } = v.basis;
  out[0] = v.target[0] + r[0] * a - u[0] * b;
  out[1] = v.target[2] * v.zScaleView + r[2] * a - u[2] * b;
  out[2] = v.target[1] + r[1] * a - u[1] * b;
}
